import React from "react";
import PropTypes from "prop-types";

import { Grid, makeStyles, Container } from "@material-ui/core";
import GrowLazyGrid from "../GrowLazyGrid";

function TwoOne(props) {
  const classes = useStyles();

  const { matches, project, getTimeOut } = props;
  return (
    <Container size="xl" disableGutters>
      <div className={classes.projectContainer}>
        <GrowLazyGrid
          src={project?.ProjectAssets?.data[1]?.attributes}
          gridWidth={12}
          imgclass={classes.fullWidth}
          getTimeOut={getTimeOut()}
          style={{ gridArea: "a" }}
        />
        <GrowLazyGrid
          src={project?.ProjectAssets?.data[2]?.attributes}
          gridWidth={12}
          imgclass={classes.fullWidth}
          getTimeOut={getTimeOut()}
          style={{ gridArea: "b" }}
        />

        <GrowLazyGrid
          src={project?.ProjectAssets?.data[0]?.attributes}
          gridWidth={6}
          imgclass={classes.fullWidth}
          getTimeOut={getTimeOut()}
          style={{ gridArea: "c" }}
        />
      </div>
    </Container>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    overflow: "hidden",

    [theme.breakpoints.down("md")]: {
      marginBottom: 8,
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "64px",
    },
  },
  fullWidth: {
    width: "100%",
    height: "100%",
    maxWidth: 1400,
    margin: "0 auto",

    [theme.breakpoints.up("md")]: {
      // margin: 0,
    },
    [theme.breakpoints.up("lg")]: {
      // margin: "4rem 4rem 1rem 4rem",
    },
  },
  projectContainer: {
    display: "grid",
    gridTemplateAreas: `"a c" "b c"`,
    gap: ".8% .8%",
  },
}));

TwoOne.propTypes = { matches: PropTypes.bool, project: PropTypes.object };
TwoOne.defaultProps = {
  matches: false,
  project: {
    images: ["/images/default.jpg"],
    images2x: ["/images/default.jpg"],
    layout: "TwoOne",
    title: "Default Title",
  },
};
export default TwoOne;
